import React from "react";
import { motion } from "framer-motion";

import { styles } from "../styles";
import { experiences } from "../constants/index";
import { SectionWrapper } from "../hoc/index";
import { fadeIn, textVariant } from "../utils/motion";

const WorkCard = ({ experience, index }) => (
  <motion.div
    variants={fadeIn("right", "spring", index * 0.3, 0.75)}
    className="relative pl-12 md:pl-16 pb-12 last:pb-0"
  >
    <span
      className="absolute left-[11px] md:left-[15px] top-0 w-4 h-4 md:w-5 md:h-5 rounded-full border-[3px] border-[#915eff] bg-[#0A0A0A] z-10"
      aria-hidden="true"
    />
    <span
      className="absolute left-[18px] md:left-[22px] top-4 md:top-5 bottom-0 w-[2px] bg-gradient-to-b from-[#915eff] to-[#3b82f6] last:hidden"
      aria-hidden="true"
    />

    <div className="absolute left-0 top-0 w-10 h-10 md:w-12 md:h-12 rounded-full bg-[#0A0A0A] border-[3px] border-[#915eff] flex items-center justify-center overflow-hidden">
      <img
        src={experience.icon}
        alt={experience.company_name}
        className="w-[60%] h-[60%] object-contain"
      />
    </div>

    <p className="text-secondary text-[14px] font-medium mb-2">
      {experience.date}
    </p>

    <div
      className="bg-[#0A0A0A] p-5 md:p-6 rounded-xl border border-transparent hover:bg-[#0F0F0F] transition-colors duration-300"
      style={{
        borderImage:
          "linear-gradient(to right, rgb(147, 51, 234), rgb(59, 130, 246)) 1",
      }}
    >
      <h3 className="text-white text-[22px] md:text-[24px] font-bold">
        {experience.title}
      </h3>
      <p className="text-secondary text-[16px] font-semibold mt-1">
        {experience.company_name}
      </p>

      {experience.intro && (
        <p className="text-white/80 text-[14px] mt-4 leading-relaxed tracking-wide">
          {experience.intro}
        </p>
      )}

      <ul className="mt-5 list-disc ml-5 space-y-2">
        {experience.points.map((point, pointIndex) => (
          <li
            key={`experience-point-${pointIndex}`}
            className="text-white/90 text-[14px] pl-1 tracking-wider"
          >
            {point}
          </li>
        ))}
      </ul>
    </div>
  </motion.div>
);

const Work = () => {
  return (
    <>
      <motion.div variants={textVariant()}>
        <p className={styles.sectionSubText}>Professional experience</p>
        <h2 className={styles.sectionHeadText}>Work</h2>
      </motion.div>

      <div className="mt-20 max-w-3xl mx-auto">
        {experiences.map((experience, index) => (
          <WorkCard key={experience.company_name + index} experience={experience} index={index} />
        ))}
      </div>
    </>
  );
};

export default SectionWrapper(Work, "work");
